import axios from "@/util/axios";
import { getApiPath } from "@/util/utils";
const baseUrl = getApiPath();

export const getMenu = () => {
  return axios({
    url: `${baseUrl}/srm-system/roleresource/allList`,
    method: "post",
    data: {},
  });
};
export const getSupplierMenu = () => {
  return axios({
    url: `${baseUrl}/srm-system/roleresourceonestop/allList`,
    method: "post",
    data: {},
  });
};
// export const getBtn = id => {
//   return axios({
//     url: `${baseUrl}/srm-system/roleresource/allBtn?ids=${id}`,
//     method: "post",
//     data: {}
//   });
// };
export const getBtn = (id) => {
  return axios({
    url: `${baseUrl}/srm-system/roleresource/allBtnNew?ids=${id}`,
    method: "post",
    data: {},
  });
};

export const getPortalUrl = () => {
  return axios({
    url: `${baseUrl}/srm-supplier-portal/supplier/getWebUrl`,
    method: "get",
  });
};
export const eventTracking = (data) => {
  return axios({
    url: `${baseUrl}/srm-system/eventTracking/send`,
    method: "post",
    data: data,
  });
};